<p-dataView [value]="customerService.publicCustomer.value.tokens"
            [paginator]="customerService.publicCustomer.value.giftCardsPurchased?.length > 5" [rows]="5">
            <ng-template let-rec pTemplate="listItem">
                <div class="d-flex w-100">
                    <div class="d-flex">
                        <fa-icon [icon]='["fab",rec.typeDisplayObject.faIcon]' size="2x" class="me-2"></fa-icon>
                        {{rec.cardNumber}}
                    </div>
                    <div class="d-flex ms-auto">
                        <i>Last used {{app.moment(rec.lastUseDateTime).format('l')}}</i>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="empty">
                <div class="d-flex w-100">
                    <div class="mx-auto">
        
                    </div>
                </div>
            </ng-template>
        </p-dataView>